import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default function getStockDetails(
    itemNo: string | undefined,
    postalCode: string | undefined,
) {
    if (!itemNo) {
        return Promise.reject(new Error(shopErrors.invalidProductItemNumber.message));
    }

    const url = getUrl(`/stock/details/${itemNo}`);

    if (postalCode) {
        url.searchParams.set('postalCode', postalCode);
    }

    return shop.get(url).json<ShopTypes.ProductStockDetailsResponse>();
}
